import { OrderIdentifierColumnType } from "@api/graphql/generated/generated-types";
import { ShipmentRow } from "../types";

export function getOrderIdentifierColumnTitle(
  orderIdentifierColumnType: OrderIdentifierColumnType,
): string {
  return orderIdentifierColumnType === OrderIdentifierColumnType.TrackingNumber
    ? "Tracking #"
    : "ID";
}

export function resolveOrderIdentifier(
  order: { trackingNumber?: string | null; displayId?: string | number | null },
  orderIdentifierColumnType: OrderIdentifierColumnType,
): string | number | undefined {
  if (orderIdentifierColumnType === OrderIdentifierColumnType.TrackingNumber) {
    return order.trackingNumber || order.displayId || undefined;
  }
  return order.displayId ?? undefined;
}

export function resolveOrderIdentifierCell(
  row: ShipmentRow | undefined,
  orderIdentifierColumnType: OrderIdentifierColumnType,
): string | number {
  return (
    resolveOrderIdentifier(
      {
        trackingNumber: row?.shipment?.trackingNumber,
        displayId: row?.orderDisplayId,
      },
      orderIdentifierColumnType,
    ) ?? ""
  );
}
